var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 34,
    viewBox: "0 0 45 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 34,
    rx: 6,
    fill: "#FFECEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 13H22.5V18L26.78 20.54L27.5 19.33L24 17.25V13ZM23.5 8C21.1131 8 18.8239 8.94821 17.136 10.636C15.4482 12.3239 14.5 14.6131 14.5 17H11.5L15.46 21.03L19.5 17H16.5C16.5 15.1435 17.2375 13.363 18.5503 12.0503C19.863 10.7375 21.6435 10 23.5 10C25.3565 10 27.137 10.7375 28.4497 12.0503C29.7625 13.363 30.5 15.1435 30.5 17C30.5 18.8565 29.7625 20.637 28.4497 21.9497C27.137 23.2625 25.3565 24 23.5 24C21.57 24 19.82 23.21 18.56 21.94L17.14 23.36C18.77 25 21 26 23.5 26C25.8869 26 28.1761 25.0518 29.864 23.364C31.5518 21.6761 32.5 19.3869 32.5 17C32.5 14.6131 31.5518 12.3239 29.864 10.636C28.1761 8.94821 25.8869 8 23.5 8Z",
    fill: "#C63232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature2);
export default __webpack_public_path__ + "static/media/feature2.1722cefe70bc341ef78bd581b29e4e40.svg";
export { ForwardRef as ReactComponent };